<template>
  <div>
    <div v-if="!loadingUnitsStatus" class="row">
      <div class="col-6">
        <camera-map
          v-model="mapConfig"
          @camera-selection="onMapCameraSelection"
          @input="setDataMap"
          @loading-map-data="setLoadingMapData"
        />
      </div>
      <div class="col-6">
        <b-alert
          v-if="!camerasMap.length && !loadingMapData"
          show
          variant="warning"
          class="p-1"
        >
          Sin cámaras seleccionadas
        </b-alert>
        <template v-else>
          <div v-if="loadingMapData" class="text-center">
            <b-spinner variant="primary" label="Spinning" />
          </div>
          <template v-else>
            <div class="row mb-1">
              <div class="col-6">
                <v-select
                  label="name"
                  v-model="centerFilter"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="centerOptions"
                  :reduce="(val) => val.id"
                  input-id="id_center"
                  placeholder="Buscar por centro"
                  @input="changeCenter"
                />
              </div>
              <div class="col-6">
                <v-select
                  label="name"
                  v-model="sectorFilter"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="sectorOptions"
                  :reduce="(val) => val.id"
                  input-id="id_sector"
                  placeholder="Buscar por sector"
                />
              </div>
            </div>
            <!-- <b-form-input
              class="mb-1"
              v-model="filter"
              placeholder="Ingresar texto"
            /> -->
            <b-table
              :items="camerasMapFiltered"
              :fields="fields"
              sticky-header
            >
              <template #head(actions)="data">
                <b-form-checkbox
                  v-model="selectAll"
                  @change="selectCameras"
                  :disabled="!currentPreviewSelected"
                />
              </template>

              <template #cell(camera.units)="data">
                {{ getDescriptionUnit(data.item.camera) }}
              </template>

              <template #cell(camera.sector)="data">
                {{ getDescriptionSector(data.item.camera) }}
              </template>

              <template #cell(actions)="data">
                <div class="text-center">
                  <b-form-checkbox
                    :id="`item-${data.item.camera.id}`"
                    v-model="data.item.add"
                    :name="`item-${data.item.camera.id}`"
                    :disabled="disabledCheckbox(data.item.camera.id)"
                    @change="sendCamerasMapSelected(data.index)"
                  />
                </div>
              </template>
            </b-table>
          </template>
        </template>
        <p v-if="errors.cameras" class="small text-danger">
          {{ errors.cameras }}
        </p>
      </div>
    </div>
    <div v-else>
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>
  </div>
</template>

<script>
import { computed,nextTick,ref,onMounted } from '@vue/composition-api';
import store from '@/store'
import CameraMap from "@/views/components/GridView/widgets/ViewsWidget/widgets/CameraMap.vue";
import vSelect from "vue-select";

export default {
  props:{
    camerasSelected: {
      type: Array
    },
    currentPreviewSelected: {
      default: null
    },
    coordinates: {
      default: null
    },
    errors: {
      type: Object
    },
    getDescriptionSector: {
      type: Function
    },
    getDescriptionUnit: {
      type: Function
    },
    fields: {
      type: Array
    },
    fullSlots: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CameraMap,
    vSelect
  },
  setup (props, { emit }) {
    //HOOKS
    onMounted(async () => {
      if (!loadingUnitsStatus.value && !units.value.length) {
        await store.dispatch("grid/getUnitsByTenant");
      }

      await store.dispatch('center/getAll');
    });
    //DATA
    const camerasMap = ref([]);

    const centerFilter = ref(null);

    const filter = ref('');

    const loadingMapData = ref(false);

    const mapConfig = ref({
      lat: (props.coordinates) ? props.coordinates.lat : 19.442217319074633,
      lng: (props.coordinates) ? props.coordinates.lng : -99.12301328580936,
      radius: (props.coordinates) ? props.coordinates.radius : 10.0,
      zoom: 8,
    });

    const sectorFilter = ref(null);

    const sectorOptions = ref([]);

    const selectAll = ref(false);

    //COMPUTED
    const camerasMapFiltered = computed(() => {
      if (centerFilter.value && sectorFilter.value) {
        return camerasMap.value.filter(camera => {
          const {  name,units } = camera.camera;
          const [unit]    = units;

          if (!unit.id_sector) {
            return false;
          }

          return (unit.id_sector === sectorFilter.value);
        });
      } else if (centerFilter.value && !sectorFilter.value) {
          return camerasMap.value.filter(camera => {
          const { name,units } = camera.camera;
          const [unit]    = units;

          if (!unit.id_sector) {
            return false;
          }

          return (unit.sector?.id_center === centerFilter.value) && (name);
        });
      } else {
        return camerasMap.value.filter(camera => camera.label);
      }
    });

    const centerOptions = computed(() => store.getters['center/getItems']);

    const loadingUnitsStatus = computed(() => store.state.grid.loadingUnits);

    const totalSlots = computed(() => (props.currentPreviewSelected) ? props.currentPreviewSelected.data.length : 0);

    const units = computed(() => store.state.grid.units);

    //METHODS
    const camerasSelectedRemove = () => {
      if (props.camerasSelected.length) {
        const camerasSelectedCopy = camerasMap.value.filter(c => c.add);

        for (const camera of camerasSelectedCopy) {
          const index = camerasMap.value.findIndex(
            c => (c.camera.id === camera.camera.id)
          );

          camerasMap.value[index].add = false;

          emit('remove-camera-from-table', {
            ...camera,
            id:camera.camera.id
          });
        }
      }
    }

    const changeCenter = (centerId) => {
      sectorFilter.value = null;

      const centerFiltered = centerOptions.value.find(
        center => center.id === centerId
      );

      sectorOptions.value = centerFiltered?.sectors || [];
    }

    const checkCamera = (camera) => {
      if (props.camerasSelected.length) {
        const cameraExists = props.camerasSelected.find(
          c => (c.id === camera.camera.id)
        );

        return (cameraExists) ? true : false;
      }

      return false;
    }

    const disabledCheckbox = (cameraId) => {
      const index = props.camerasSelected.findIndex(
        camera => (camera.id === cameraId)
      );

      return (index === -1) && (props.fullSlots || props.currentPreviewSelected === null);
    }

    const findCameraForDisabled = (cameraId) => {

      const index = camerasMap.value.findIndex(
        camera => (camera.camera.id === cameraId)
      );

      camerasMap.value[index].add = false;
    }

    const onMapCameraSelection = (data) => {
      nextTick(() => {
        camerasMap.value = (data.length)
        ? data.map(d => ({
          ...d,
          add: checkCamera(d)
        }))
        : [];
      });
    }

    const selectCameras = (value) => {
      (value) ? selectAllCameras() : camerasSelectedRemove();
    }

    const selectAllCameras = () => {
      const camerasSelectedArray = camerasMap.value.slice(0, totalSlots.value);

      camerasSelectedRemove();

      camerasSelectedArray.forEach((camera,index) => {
        camerasMap.value[index].add = true;
        emit('set-cameras-selected-from-map', camera );
      });
    }

    const sendCamerasMapSelected = (index) => {
      const cameraFromIndex = camerasMap.value[index];

      emit('set-cameras-selected-from-map', { ...cameraFromIndex });

      totalCamerasSelectedCheck(cameraFromIndex);
    }

    const setDataMap = (coordinates) => {
      emit('add-coordinates', coordinates)
    }

    const setLoadingMapData = (value) => {
      loadingMapData.value = value;
    }

    const totalCamerasSelectedCheck = (cameraFromIndex) => {
      if (!cameraFromIndex.add) {
        selectAll.value = false;
        return
      }

      const camerasMapSelected = camerasMap.value.filter(camera => camera.add);

      if (camerasMapSelected.length === totalSlots.value) {
        selectAll.value = true;
      }
    }

    return {
      camerasMap,
      centerFilter,
      filter,
      loadingMapData,
      mapConfig,
      sectorFilter,
      sectorOptions,
      selectAll,

      camerasMapFiltered,
      centerOptions,
      disabledCheckbox,
      loadingUnitsStatus,
      units,

      changeCenter,
      findCameraForDisabled,
      onMapCameraSelection,
      selectCameras,
      sendCamerasMapSelected,
      setDataMap,
      setLoadingMapData
    }
  }
}
</script>
